import { render } from "./QuoteResultsRender.vue?vue&type=template&id=72315cbe&scoped=true&ts=true"
import script from "./QuoteResultsRender.vue?vue&type=script&lang=ts"
export * from "./QuoteResultsRender.vue?vue&type=script&lang=ts"

import "./QuoteResultsRender.vue?vue&type=style&index=0&id=72315cbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72315cbe"]])

export default __exports__